export enum CheckoutFlowEnum {
    DIRECT_CHECKOUT = "DIRECT_CHECKOUT",
    ECOM_CHECKOUT = "ECOM_CHECKOUT",
    ADD_STUDENT = "ADD_STUDENT",
    PROGRAM_RENEWAL = "PROGRAM_RENEWAL",
    SUBJECT_CHANGE_FEE_PAYMENT = "SUBJECT_CHANGE_FEE_PAYMENT",
    PREMIUM_SERVICE_PAYMENT = "PREMIUM_SERVICE_PAYMENT"
}
